<template>
  <div class="page-bar">
    <div class="page-bar__content">
      <div class="page-bar__title-section">
        <div v-if="imageSrc" class="page-bar__image-wrapper">
          <v-img
            :src="imageSrc"
            :alt="imageAlt"
            :width="computedImageSize"
            :height="computedImageSize"
            contain
            class="page-bar__image"
          />
        </div>
        <div class="page-bar__text">
          <h1 class="page-bar__title white--text headline">
            {{ title }}
          </h1>
          <div
            v-if="subtitle"
            class="page-bar__subtitle white--text subtitle-1"
            v-html="subtitle"
          ></div>
        </div>
      </div>
      <div class="page-bar__actions">
        <slot name="actions"></slot>
      </div>
    </div>
    <v-divider class="page-bar__divider"></v-divider>
  </div>
</template>

<script>
export default {
  name: "PageBar",
  props: {
    // Title text to display
    title: {
      type: String,
      required: true,
    },
    // Optional subtitle text shown under the title
    subtitle: {
      type: String,
      default: "",
    },
    // Optional left image (e.g., thumbnail) shown next to the title
    imageSrc: {
      type: String,
      default: "",
    },
    imageAlt: {
      type: String,
      default: "Thumbnail",
    },
    // Size in px for the left image
    imageSize: {
      type: [Number, String],
      default: 60,
    },
  },
  computed: {
    computedImageSize() {
      return typeof this.imageSize === "number"
        ? `${this.imageSize}px`
        : this.imageSize;
    },
  },
  data: () => ({}),
  methods: {},
};
</script>

<style lang="scss">
@use "@/styles/PageBar.scss";

.page-bar__subtitle a {
  color: #ffffff !important;
  text-decoration: underline;
}

.page-bar__subtitle a:hover,
.page-bar__subtitle a:focus {
  opacity: 0.9;
}
</style>
